import React from "react";
import { Card, Form, Row, Col, Button, Badge } from "react-bootstrap";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const OfficeLocationsSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const updateOffice = (index, updates) => {
    const updatedOffices = data.offices.map((office, i) =>
      i === index ? { ...office, ...updates } : office
    );
    handleChange("offices", updatedOffices);
  };

  const addOffice = () => {
    const newOffice = {
      location: "",
      name: "",
      designation: "",
      address: "",
      phone: "",
    };
    handleChange("offices", [...(data.offices || []), newOffice]);
  };

  const removeOffice = (index) => {
    const updatedOffices = data.offices.filter((_, i) => i !== index);
    handleChange("offices", updatedOffices);
  };

  const moveOffice = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= data.offices.length) return;

    const reorderedOffices = [...data.offices];
    const [movedItem] = reorderedOffices.splice(index, 1);
    reorderedOffices.splice(newIndex, 0, movedItem);

    handleChange("offices", reorderedOffices);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Office Locations Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <h6 className="fw-bold mb-3">Offices</h6>
          {data.offices?.map((office, index) => (
            <div
              key={index}
              className="border rounded p-3 mb-3 bg-light-subtle"
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Office {index + 1}</h6>
                <div className="d-flex align-items-center gap-2">
                  {data.offices.length > 1 && (
                    <div className="d-flex align-items-center gap-1">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => moveOffice(index, -1)}
                        disabled={index === 0}
                        title="Move up"
                        className="p-1 d-flex align-items-center justify-content-center"
                        style={{ width: "28px", height: "28px" }}
                      >
                        <FiChevronUp size={16} />
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => moveOffice(index, 1)}
                        disabled={index === data.offices.length - 1}
                        title="Move down"
                        className="p-1 d-flex align-items-center justify-content-center"
                        style={{ width: "28px", height: "28px" }}
                      >
                        <FiChevronDown size={16} />
                      </Button>
                      <Badge bg="secondary" className="ms-1">
                        {index + 1} / {data.offices.length}
                      </Badge>
                    </div>
                  )}
                  {data.offices.length > 1 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removeOffice(index)}
                    >
                      Remove
                    </Button>
                  )}
                </div>
              </div>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Location</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g., Head Office, Regional Office"
                      value={office.location || ""}
                      onChange={(e) =>
                        updateOffice(index, { location: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact Person Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      value={office.name || ""}
                      onChange={(e) =>
                        updateOffice(index, { name: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Designation</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g., Manager, Director"
                      value={office.designation || ""}
                      onChange={(e) =>
                        updateOffice(index, { designation: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Phone Number"
                      value={office.phone || ""}
                      onChange={(e) =>
                        updateOffice(index, { phone: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-0">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Full Address"
                  value={office.address || ""}
                  onChange={(e) =>
                    updateOffice(index, { address: e.target.value })
                  }
                />
              </Form.Group>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addOffice}>
            + Add Office
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default OfficeLocationsSection;
